import { all, put, takeEvery } from "redux-saga/effects";

import INTERVIEW from "../../utils/api/interview";
import CANDIDATE from "../../utils/api/candidate";
import { GET_INTERVIEW, GET_FEEDBACK } from "../action/types";
import {
  getInterviewFailure,
  getInterviewSuccess,
  getFeedbackSuccess,
  getFeedbackFailure,
} from "../action";

interface SagaAction {
  type: string;
  payload?: any;
}

function* getInterviewRequest(action: SagaAction): Generator<any, void, any> {
  try {
    const res = yield INTERVIEW.get(
      `getInterview/${action.payload.interviewId}/${action.payload.roomId}?signature=${action.payload.signature}&expires=${action.payload.expires}`
    );
    if (res.status === 200) {
      yield put(getInterviewSuccess(res.data.result));
    } else yield put(getInterviewFailure());
  } catch (e: any) {
    yield put(getInterviewFailure());
  }
}

function* getFeedbackRequest(action: SagaAction): Generator<any, void, any> {
  try {
    const res = yield CANDIDATE.get(
      `interviews/getInterview/${action.payload.interviewId}/${action.payload.roomId}?signature=${action.payload.signature}&expires=${action.payload.expires}`
    );
    if (res.status === 200) {
      yield put(getFeedbackSuccess(res.data.result));
    } else yield put(getFeedbackFailure());
  } catch (e: any) {
    yield put(getFeedbackFailure());
  }
}

export function* watchGetInterviewAPI() {
  yield takeEvery(GET_INTERVIEW, getInterviewRequest);
}

export function* watchGetFeedbackAPI() {
  yield takeEvery(GET_FEEDBACK, getFeedbackRequest);
}

export default function* rootSaga() {
  yield all([watchGetInterviewAPI(), watchGetFeedbackAPI()]);
}
